import { textColor } from './common/color';
export var getTooltip = function getTooltip() {
  return {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
      shadowStyle: {
        color: 'rgba(150, 150, 150, 0.1)'
      }
    }
  };
};
export var getLabel = function getLabel() {
  return {
    color: textColor.gray
  };
};
export default {
  barWidth: '50%',
  barGap: '2%',
  itemStyle: {
    normal: {
      barBorderWidth: '0',
      barBorderColor: '#ffffff'
    },
    emphasis: {
      barBorderWidth: '0',
      barBorderColor: '#ffffff'
    }
  }
};